<template>
  <!-- The status price tag (spec §5.1-5.2) by meaning instead of by CSS class: say the tone, never the colour. A label is read, never pressed. -->
  <span class="status-chip" :class="`status-chip--${TONES[tone]}`">{{ label }}</span>
</template>

<script lang="ts" setup>
defineProps<{ tone: 'mint' | 'signal' | 'plum' | 'ice' | 'ash'; label: string }>();

// The modifiers main.css already has
const TONES = { mint: 'green', signal: 'orange', plum: 'plum', ice: 'blue', ash: 'gray' } as const;
</script>
